import React, { useContext } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import PaymentPending from './PaymentPending';
import PaymentDone from './PaymentDone';
import { RegistrationStatus } from '@/modules/common/enums';
import { Typography } from '@pw-tech/omni-ui';
declare global {
  interface Window {
    Razorpay: any;
  }
}
const AdmissionFee = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const renderAdmissionFeeScreenBasedOnStatus = (status: string) => {
    const isAdmissionFeePaid = registrationDetails?.isAdmissionFeePaid;
    if (isAdmissionFeePaid) {
      return <PaymentDone />;
    }
    switch (status) {
      case RegistrationStatus.admission_fee_pending:
        return <PaymentPending />;
      case RegistrationStatus.admission_fee_paid:
        return <PaymentDone />;
      default:
        return <Typography variant="heading3">Invalid Admission Fee Status</Typography>;
    }
  };
  return <>{renderAdmissionFeeScreenBasedOnStatus(registrationDetails?.status ?? '')}</>;
};
export default AdmissionFee;